
import { Placement } from '@post-office/placements-frontend/jira-issue-view-contextual-survey';
export default Placement;
